<template>
    <div class="uk-padding">
        <div class="uk-container uk-container-small">
            <h2 class="uk-heading-line specHeading"><span>Get in touch/ Request a consultation</span></h2>
            <p>We want to hear from you so feel free to contact us</p>
            <form @submit.prevent="validateForm('contactForm')" data-vv-scope="contactForm">
                <fieldset class="uk-fieldset">


                    <div class="uk-margin">
                        <input name="contactName" v-model="contactName" v-validate="'required'"  data-vv-as="name" class="uk-input" :class="{'input': true, 'is-danger': errors.has('contactForm.contactName') }" type="text" placeholder="Name">
                        <span class="uk-text-small uk-text-danger">{{ errors.first('contactForm.contactName') }}</span>


                    </div>
                    <div class="uk-margin">
                        <input name="contactEmail" v-model="contactEmail"
                               v-validate="'required|email'"  data-vv-as="email" class="uk-input"
                               :class="{'input': true, 'is-danger': errors.has('contactForm.contactEmail') }"
                               type="email" placeholder="Email">
                        <span class="uk-text-small uk-text-danger">{{ errors.first('contactForm.contactEmail') }}</span>
                    </div>
                    <div class="uk-margin">

                        <input name="contactPhone" v-model="contactPhone" v-validate="'required|min:7'" data-vv-as="phone number" class="uk-input" type="number" placeholder="Phone"
                               :class="{'input': true, 'is-danger': errors.has('contactForm.contactPhone') }" >
                        <small class="uk-text-small uk-text-muted">Example: 1345XXXXXXX</small>
                        <br>
                        <span class="uk-text-small uk-text-danger">{{ errors.first('contactForm.contactPhone') }}</span>
                    </div>

                    <div class="uk-margin">
                        <select name="contactTime" v-model="contactTime" v-validate="'required'" data-vv-as="reply time" class="uk-select"
                                :class="{'input': true, 'is-danger': errors.has('contactForm.contactTime') }">
                            <option selected="selected" disabled>Please select the best time for us to contact you?</option>
                            <option >8: 00 am to 10: 00 am</option>
                            <option >10: 00 am to 12: 00 am</option>
                            <option >10: 00 am to Noon</option>
                            <option >Noon am to 2:30 pm</option>
                            <option >2: 30 pm am to 5:00 pm</option>
                            <option >Just after 5 pm </option>
                        </select>
                        <span class="uk-text-small uk-text-danger">{{ errors.first('contactForm.contactTime') }}</span>
                    </div>

                    <div class="uk-margin">
                        <textarea name="contactBody" v-model="contactBody" v-validate="'required'" data-vv-as="message/query" class="uk-textarea" rows="5" placeholder="Please tell us how we can help"
                                  :class="{'input': true, 'is-danger': errors.has('contactForm.contactBody') }"></textarea>
                        <span class="uk-text-small uk-text-danger">{{ errors.first('contactForm.contactBody') }}</span>
                    </div>
                    <div class="uk-margin">
                        <button class="uk-button uk-button-primary" type="submit">Send </button>
                    </div>

                </fieldset>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import UIkit from 'uikit'
    export default {
        name: "contactForm",
        data(){
            return {
                contactName: '',
                contactEmail: '',
                contactPhone: '',
                contactTime: '',
                contactBody: ''
            }
        },
        methods: {
            mail: function () {
                console.log(this.contactName)

                let params = new URLSearchParams();
                params.append('contactName', this.contactName);
                params.append('contactEmail', this.contactEmail);
                params.append('contactPhone', this.contactPhone);
                params.append('contactTime', this.contactTime);
                params.append('contactBody', this.contactBody);
                let self = this
                axios.post('https://mail.fincoronline.com', params)
                    .then(function (response) {
                        //console.log(response);

                        if (response.data.reply === 1){
                            self.$validator.reset()
                            UIkit.notification({message: '<span uk-icon=\'icon: check\'></span> Your message/query has been received. We will contact you as soon as possible.', pos: 'top-right', status:'success'})
                            self.contactName = ''
                            self.contactEmail = ''
                            self.contactPhone = ''
                            self.contactTime = ''
                            self.contactBody = ''
                        }else{
                            UIkit.notification({message: 'Please try sending your message again, something went wrong.', status:'danger', pos: 'top-right'})
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

               /* axios.post( 'http://localhost:8000', {
                    contactName: this.$refs.contactName.value,
                    contactEmail: this.$refs.contactEmail.value,
                    contactPhone: this.$refs.contactPhone.value,
                    contactTime: this.$refs.contactTime.value,
                    contactBody: this.$refs.contactBody.value,
                })
                    .then(function (response) {
                        console.log(response);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });*/

        },
            validateForm(scope) {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        // eslint-disable-next-line
                        //alert('Form Submitted!');
                        this.mail()
                    }
                });
            }
    }
    }
</script>

<style scoped>

</style>